import React, { useState } from "react";
import PropTypes from "prop-types";

import { useHistory } from "react-router-dom";

import { Button, Fieldset, Field, Control } from "rbx";
import { useMutation, useApolloClient } from "react-apollo";
import Section from "../Section";
import { EMPLOYEE_EXISTS_ON_USER_QUERY } from "../../graphql/Employees/Employees.graphql";
import { CREATE_USER_MUTATION } from "../../graphql/Users/Users.graphql";
import { ourToast as toast } from "../../utils";

import UserForm from "./UserForm";

const AddUserForm = ({ onComplete }) => {
  const client = useApolloClient();
  const [state, setState] = useState({
    UserId: "",
    Password: "",
    LastName: "",
    FirstName: "",
    MiddleName: "",
    Active: true,
    CompanyId: localStorage.getItem("user_company") || "",
    ConfirmPassword: ""
  });
  const [FromEmployee, setFromEmployee] = useState(false);

  const history = useHistory();

  const [createUserMutation, { loading }] = useMutation(CREATE_USER_MUTATION, {
    refetchQueries: ["ALL_USERS_QUERY"]
  });

  const onChange = async e => {
    if (e.target.name === "FromEmployee") {
      setFromEmployee(e.target.checked);
      if (!e.target.checked) {
        setState({
          ...state,
          LastName: "",
          FirstName: "",
          MiddleName: "",
          EmployeeRecIdRef: 0,
          UserId: ""
        });
      }
    } else if (e.target.name === "EmployeeRecIdRef") {
      try {
        const {
          data: { EmployeeExistsOnUser }
        } = await client.query({
          query: EMPLOYEE_EXISTS_ON_USER_QUERY,
          variables: {
            RecId: parseInt(e.target.value)
          },
          fetchPolicy: "network-only"
        });
        if (EmployeeExistsOnUser) {
          setState({
            ...state,
            LastName: EmployeeExistsOnUser.Employee.LastName,
            FirstName: EmployeeExistsOnUser.Employee.FirstName,
            MiddleName: EmployeeExistsOnUser.Employee.MiddleName,
            EmployeeRecIdRef: parseInt(EmployeeExistsOnUser.Employee.RecId),
            UserId: EmployeeExistsOnUser.Nickname
          });
        } else {
          setState({
            ...state,
            LastName: "",
            FirstName: "",
            MiddleName: "",
            EmployeeRecIdRef: 0,
            UserId: ""
          });
          toast.error("The selected employee is being used by another user.");
        }
      } catch (error) {
        toast.error("Error finding User.");
      }
    } else {
      const value =
        e.target.type === "checkbox" ? e.target.checked : e.target.value;
      setState({ ...state, [e.target.name]: value });
    }
  };

  const handleSave = async e => {
    e.preventDefault();
    try {
      if (state.Password !== state.ConfirmPassword) {
        throw new Error("Passwords must match. Try again.");
      }
      const {
        UserId,
        Password,
        LastName,
        FirstName,
        MiddleName,
        Active,
        CompanyId,
        EmployeeRecIdRef
      } = state;
      const { data } = await createUserMutation({
        variables: {
          data: {
            UserId,
            Password,
            LastName,
            FirstName,
            MiddleName,
            Active,
            CompanyId,
            EmployeeRecIdRef: EmployeeRecIdRef === 0 ? null : EmployeeRecIdRef
          }
        }
      });
      onComplete();
      toast.success("User created successfully.");
      if (data?.createUser?.RecId) {
        history.push(`/admin/users/${data.createUser.RecId}/details`);
      }
    } catch (err) {
      if (err.message.includes("Cannot insert duplicate key")) {
        toast.error("The User Id is being used by another user");
      } else {
        toast.error("Error creating User.");
      }
    }
  };
  return (
    <Section title="Add User">
      <form id="create-user-form" onSubmit={handleSave}>
        <Fieldset disabled={loading}>
          <UserForm
            editing
            newUser
            showPasswordInput
            FromEmployee={FromEmployee}
            inputs={state}
            showUserGroupMembershipField={false}
            onChange={onChange}
          />
          <hr />
          <Field kind="group">
            <Control>
              <Button color="primary" form="create-user-form" type="submit">
                Submit
              </Button>
            </Control>
            <Control>
              <Button type="button" onClick={onComplete}>
                Cancel
              </Button>
            </Control>
          </Field>
        </Fieldset>
      </form>
    </Section>
  );
};

AddUserForm.propTypes = {
  onComplete: PropTypes.func
};
export default AddUserForm;
